import createIcon from '../../createIcon';

/**
 * @component @name PersonAddAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgOEMxMyA1Ljc5IDExLjIxIDQgOSA0QzYuNzkgNCA1IDUuNzkgNSA4QzUgMTAuMjEgNi43OSAxMiA5IDEyQzExLjIxIDEyIDEzIDEwLjIxIDEzIDhaTTExIDhDMTEgOS4xIDEwLjEgMTAgOSAxMEM3LjkgMTAgNyA5LjEgNyA4QzcgNi45IDcuOSA2IDkgNkMxMC4xIDYgMTEgNi45IDExIDhaTTEgMThWMjBIMTdWMThDMTcgMTUuMzQgMTEuNjcgMTQgOSAxNEM2LjMzIDE0IDEgMTUuMzQgMSAxOFpNMyAxOEMzLjIgMTcuMjkgNi4zIDE2IDkgMTZDMTEuNjkgMTYgMTQuNzggMTcuMjggMTUgMThIM1pNMjAgMTVWMTJIMjNWMTBIMjBWN0gxOFYxMEgxNVYxMkgxOFYxNUgyMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PersonAddAlt = createIcon('PersonAddAlt', [
  [
    'path',
    {
      d: 'M13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12C11.21 12 13 10.21 13 8ZM11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6C10.1 6 11 6.9 11 8ZM1 18V20H17V18C17 15.34 11.67 14 9 14C6.33 14 1 15.34 1 18ZM3 18C3.2 17.29 6.3 16 9 16C11.69 16 14.78 17.28 15 18H3ZM20 15V12H23V10H20V7H18V10H15V12H18V15H20Z',
      key: '809abu',
    },
  ],
]);

export default PersonAddAlt;
